import {
  DEFAULT_RUNTIME,
  DEFAULT_ARCHITECTURE,
  LAMBDA_RUNTIMES,
  LAMBDA_ARCHITECTURES,
} from 'config-editor-common';
import { EnumSelect } from './EnumSelect';

// Only arm64 gets a cased display label; x86_64 reads correctly as-is.
const ARCHITECTURE_OPTIONS = LAMBDA_ARCHITECTURES.map(
  a => [a, a === 'arm64' ? 'ARM64' : a] as const,
);

interface RuntimeArchitectureFieldsProps {
  runtime: string;
  architecture: string;
  onRuntimeChange: (value: string) => void;
  onArchitectureChange: (value: string) => void;
  runtimeLabel?: string;
  architectureLabel?: string;
  runtimeLabelId?: string;
  architectureLabelId?: string;
  showInGrid?: boolean;
}

export const RuntimeArchitectureFields = ({
  runtime,
  architecture,
  onRuntimeChange,
  onArchitectureChange,
  runtimeLabel = 'Runtime',
  architectureLabel = 'Architecture',
  runtimeLabelId,
  architectureLabelId,
  showInGrid = true,
}: RuntimeArchitectureFieldsProps) => (
  <>
    <EnumSelect
      value={runtime}
      onChange={onRuntimeChange}
      label={runtimeLabel}
      labelId={runtimeLabelId}
      options={LAMBDA_RUNTIMES}
      defaultValue={DEFAULT_RUNTIME}
      gridItem={showInGrid}
    />
    <EnumSelect
      value={architecture}
      onChange={onArchitectureChange}
      label={architectureLabel}
      labelId={architectureLabelId}
      options={ARCHITECTURE_OPTIONS}
      defaultValue={DEFAULT_ARCHITECTURE}
      gridItem={showInGrid}
    />
  </>
);
